import swal from "sweetalert2";

export async function promptForDirtyFormRefresh() {
	const confirmation = await swal.fire({
		title: "Refresh form?",
		html:
				`<p>You have made changes to entities that are not yet reflected in the form.</p>
				<p>In order to see these changes, you will have to reload the form.</p>
				<p>Would you like to reload the form now?</p>
				`,
		showCloseButton: true,
		type: "warning",
		showCancelButton: true,
		confirmButtonColor: "#8CC541",
		confirmButtonText: "Reload",
		focusCancel: true,
		reverseButtons: true
	});

	return !confirmation.dismiss;
}
